import { MemoryProxyStorage } from '../memoryProxy/MemoryProxyStorage';
export class LocalStorage {
    constructor() {
        return MemoryProxyStorage.applyProxy(this, "LocalStorage");
    }
    isSupported() {
        let result;
        try {
            const key = "isSupportedLocalStorageKey";
            const value = "isSupportedLocalStorageValue";
            localStorage.setItem(key, value);
            if (localStorage.getItem(key) === value) {
                localStorage.removeItem(key);
                result = true;
            }
        }
        catch (ex) {
            result = false;
        }
        finally {
            return result;
        }
    }
    get(key, isJson = true) {
        try {
            const data = localStorage.getItem(key);
            return isJson ? JSON.parse(data) : data;
        }
        catch (ex) {
            return null;
        }
    }
    set(key, object, isJson = true) {
        let success;
        try {
            let value = isJson ? JSON.stringify(object) : object;
            localStorage.setItem(key, value);
            success = !this.checkIsNullOrUndefined(this.get(key, isJson));
        }
        catch (ex) {
            success = false;
        }
        finally {
            return success;
        }
    }
    delete(key) {
        let success;
        try {
            localStorage.removeItem(key);
            success = true;
        }
        catch (ex) {
            success = false;
        }
        finally {
            return success;
        }
    }
    clear() {
        let success;
        try {
            localStorage.clear();
            success = true;
        }
        catch (ex) {
            success = false;
        }
        finally {
            return success;
        }
    }
    getAllKeys() {
        let keys = [];
        try {
            keys = Object.keys(localStorage);
        }
        catch (error) {
        }
        finally {
            return keys;
        }
    }
    checkIsNullOrUndefined(result) {
        return result === undefined || result === null;
    }
}
